import { useEffect, useMemo, useState } from 'react';
import { useSession, useUser } from '@clerk/clerk-react';
import { useDashboardAssistantDock } from '../../contexts/DashboardAssistantDockContext';
import type { NativeAudiencePersistenceIdentity } from './nativeAudiencePersistence';
import { getOrCreateNativeAudienceTabId } from './nativeAudienceTabLease';

export function bindNativeAudienceTabLease(onLease: (tabId: string) => void) {
  let mounted = true;
  void getOrCreateNativeAudienceTabId().then((leasedTabId) => {
    if (mounted) onLease(leasedTabId);
  }).catch(() => {
    // An unexpected identity failure leaves persistence unavailable rather
    // than exposing an owner that was never leased.
  });
  return () => {
    mounted = false;
  };
}

export function useNativeAudiencePersistenceIdentity(): NativeAudiencePersistenceIdentity | null {
  const { user } = useUser();
  const { session } = useSession();
  const { activeSessionId } = useDashboardAssistantDock();
  const [tabId, setTabId] = useState<string | null>(null);

  useEffect(() => {
    return bindNativeAudienceTabLease(setTabId);
  }, []);

  return useMemo(() => user?.id && session?.id && tabId ? {
    actorId: user.id,
    sessionId: session.id,
    assistantSessionId: activeSessionId,
    tabId,
  } : null, [activeSessionId, session?.id, tabId, user?.id]);
}
